import { useId, useState } from 'react';
import SeccionConectores from './conectores/SeccionConectores';
import SeccionAgentes from './conectores/SeccionAgentes';
import SeccionObservabilidad from './conectores/SeccionObservabilidad';
import SeccionTarifas from './conectores/SeccionTarifas';

type Tab = 'conectores' | 'agentes' | 'observabilidad' | 'tarifas';

const TABS: { id: Tab; label: string }[] = [
  { id: 'conectores', label: 'Conectores LLM' },
  { id: 'agentes', label: 'Asignación por agente' },
  { id: 'observabilidad', label: 'Observabilidad' },
  { id: 'tarifas', label: 'Tarifas y gasto' },
];

export default function Conectores() {
  const [tab, setTab] = useState<Tab>('conectores');
  // Fuerza recarga de la sección de agentes cuando cambian los conectores.
  const [version, setVersion] = useState(0);
  const baseId = useId();

  return (
    <div className="flex flex-col gap-5">
      {/* Encabezado de página (patrón de la guía visual) */}
      <header>
        <h1 className="titulo-pagina">Setup LLMs</h1>
        <p className="subtitulo-pagina">
          Conecta proveedores, asigna modelos por agente y revisa el uso.
        </p>
      </header>

      {/* Tabs como pills segmentadas (ref. visual aprobada) */}
      <div
        role="tablist"
        aria-label="Configuración de agentes y conectores"
        className="flex flex-wrap gap-2"
      >
        {TABS.map((t) => {
          const activo = tab === t.id;
          return (
            <button
              key={t.id}
              id={`${baseId}-${t.id}`}
              role="tab"
              type="button"
              aria-selected={activo}
              aria-controls={`${baseId}-${t.id}-panel`}
              onClick={() => setTab(t.id)}
              className={`pill ${activo ? 'pill-activa' : ''}`}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      <div
        id={`${baseId}-${tab}-panel`}
        role="tabpanel"
        aria-labelledby={`${baseId}-${tab}`}
      >
        {tab === 'conectores' && (
          <SeccionConectores onCambio={() => setVersion((v) => v + 1)} />
        )}
        {tab === 'agentes' && <SeccionAgentes key={version} />}
        {tab === 'observabilidad' && <SeccionObservabilidad />}
        {tab === 'tarifas' && <SeccionTarifas />}
      </div>
    </div>
  );
}
